export default __webpack_public_path__ + "static/hero-viitorul-m-72f118d10e95fd9cd7a7203be7934d1f.jpg";